export default "__VITE_ASSET__CFjsFJiY__"